import React from 'react'

import LineSkeleton from '../../Mantine/Skeleton/line'
import * as S from '../styles'

export default function SkeletonCards() {
  return (
    <S.Container>
      <S.GridVideos>
        {Array.from({ length: 8 }).map((_, index) => (
          <S.VideoWrapper key={`skeleton-${index}`}>
            <S.ContainerVideo>
              <LineSkeleton height="100%" width="100%" visible />
            </S.ContainerVideo>

            <S.ContainerDetalhesVideo>
              <S.ContainerDescricaoVideo>
                <S.SkeletonTitulo>
                  <LineSkeleton height={19} width="80%" visible />
                </S.SkeletonTitulo>
                <LineSkeleton height={15} width="100%" visible />
                <S.SkeletonDescricao>
                  <LineSkeleton height={15} width="90%" visible />
                </S.SkeletonDescricao>
              </S.ContainerDescricaoVideo>

              <S.Divisoria />

              <S.ContainerDetalhes>
                <S.ContainerUploaderVideo>
                  <S.ContainerFoto>
                    <S.SkeletonFoto>
                      <LineSkeleton height={40} width={40} visible />
                    </S.SkeletonFoto>
                  </S.ContainerFoto>
                  <S.ContainerApresentador>
                    <LineSkeleton height={14} width={120} visible />
                  </S.ContainerApresentador>
                </S.ContainerUploaderVideo>
                <S.ContainerTempo>
                  <LineSkeleton height={16} width={60} visible />
                </S.ContainerTempo>
              </S.ContainerDetalhes>
            </S.ContainerDetalhesVideo>
          </S.VideoWrapper>
        ))}
      </S.GridVideos>
    </S.Container>
  )
}
